<template>
    <div
        :style="{
            left: start.x + 'px',
            top: start.y + 'px',
            width: width + 'px',
            height: height + 'px',
        }"
        class="area"
      @mousedown="handleMouseDownOnArea"
    ></div>
</template>

<script>
export default {
    props: {
        start: {
            type: Object,
            default: () => {},
        },
        width: {
            type: Number,
            default: 0,
        },
        height: {
            type: Number,
            default: 0,
        },
        currentScale: {
          type: Number,
          default: 1,
        }
    },
    methods:{
      handleMouseDownOnArea(e) {
        e.stopPropagation();
        let startX = e.clientX;
        // console.log('down---', startX)
        let startY = e.clientY;
        let hasMove = false;
        const move = (moveEvent) => {
          // console.log('move---', moveEvent.clientX, this.currentScale)
          hasMove = true;
          const curX = moveEvent.clientX;
          const curY = moveEvent.clientY;
          const missX = (curX - startX) / this.currentScale;
          const missY = (curY - startY) / this.currentScale;
          startX = curX;
          startY = curY;
          this.$emit('areaMove', {missX, missY})
        };

        const up = () => {
          hasMove && this.$store.commit("recordSnapshot");
          document.removeEventListener("mousemove", move);
          document.removeEventListener("mouseup", up);
        };

        document.addEventListener("mousemove", move);
        document.addEventListener("mouseup", up);
      }
    }

}
</script>

<style lang="scss" scoped>
.area {
    border: 2px solid #1c92ff;
    background: rgba(28, 146, 255, 0.12);
    position: absolute;
    // &:hover {
    //   cursor: move;
    // }
}
</style>